import { accessor } from 'src/store';
import type {
    NodeCfg,
    NodeKind,
} from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';

/**
 * applies creating a socket from a node.
 *
 * This updates vuex, so update your node config before calling this.
 */
export function createNodeSocket<K extends NodeKind> (opts: {
    newNodeCfg: NodeCfg<K>;
}): void {
    const {
        newNodeCfg,
    } = opts;

    const entityData = accessor.entityAsType('appletDesignVersion');
    if (!entityData) {
        return;
    }

    const flow = Object.values(entityData.config.flows).find(f => Boolean(f.nodes[newNodeCfg.id]));
    if (!flow) {
        return;
    }

    accessor.setPageEntity({
        entity: {
            ...entityData,
            config: {
                ...entityData.config,
                flows: {
                    ...entityData.config.flows,
                    [flow.id]: {
                        ...flow,
                        nodes: {
                            ...flow.nodes,
                            [newNodeCfg.id]: {
                                ...newNodeCfg,
                            },
                        },
                    },
                },
            },
        },
        type: 'appletDesignVersion',
    });
}
